export default "__VITE_ASSET__Ve7x7Nwo__"